import FilterAndValue from "components/filters/FilterAndValue";
import React, { useContext } from "react";
import { DisplayMode } from "./PlanningMapApp";
import { getListUniqueKey } from "./planningMapHelpers";
import PlanningMapList from "./PlanningMapList";
import { FilterContext } from "components/filters/FilterContext";
import PlanningMapVirtualizedListItem from "./PlanningMapVirtualizedListItem";
import { GoogleMapAirportPinForMapList } from "components/GoogleMap/pins/PinForList";
import { AirportForMap } from "./AirportForMap";
import AirportSizeFilter from "components/filters/Filters/AirportSizeFilter";
import FilterValue from "components/filters/FilterValue";
interface Props {
  airports: server.dto.Airport[]
  selectedAirports: server.dto.Airport[]
  total: number
  hoveredAirports: server.dto.Airport[]
  isLayerSelected: boolean
  onLayerToggle: () => void
  onViewAllClick: () => void
  displayMode: DisplayMode
  onDisplayModeChange: (displayMode: DisplayMode) => void;
  onSidePanelOpen: (item: server.dto.Airport) => void
  isInitialLoading: boolean
  error?: string
  onHover: (airport: server.dto.Airport) => void
  isFetching: boolean
}

const AirportRenderer = (props: { data: Props, index: number, style: React.CSSProperties }) => {
  const airport = props.data.airports[props.index];
  return <PlanningMapVirtualizedListItem {...props}>
    <AirportForMap
      onOpen={() => props.data.onSidePanelOpen(airport)}
      hovered={props.data.hoveredAirports.findIndex(v => v.airportId === airport.airportId) !== -1}
      selected={props.data.selectedAirports.includes(airport)}
      airport={airport}
      onHover={props.data.onHover}
    />
  </PlanningMapVirtualizedListItem>
}

const PlanningMapAirportList = (props: Props) => {
  const { isDefault } = useContext(FilterContext);
  return <PlanningMapList
    displayMode={props.displayMode}
    onDisplayModeChange={props.onDisplayModeChange}
    uniqueId={getListUniqueKey("airport")}
    rowHeight={64}
    isLayerSelected={props.isLayerSelected}
    onLayerToggle={props.onLayerToggle}
    onViewAllClick={props.onViewAllClick}
    title={RESX.Flight.Airports}
    total={props.total}
    pin={<GoogleMapAirportPinForMapList />}
    hasFilters={!isDefault}
    isInitialLoading={props.isInitialLoading}
    error={props.error}
    numberOfRows={props.airports.length}
    itemData={props}
    renderer={AirportRenderer}
    selectedItems={props.selectedAirports}
    isFetching={props.isFetching}
  >
    <FilterAndValue>
      <AirportSizeFilter />
      <FilterValue filterKey="airportSize" />
    </FilterAndValue>
  </PlanningMapList>
}

export default PlanningMapAirportList;